import { render, staticRenderFns } from "./PersonalDataFormPanel.vue?vue&type=template&id=515fa52f&scoped=true"
import script from "./PersonalDataFormPanel.vue?vue&type=script&lang=ts"
export * from "./PersonalDataFormPanel.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDataFormPanel.vue?vue&type=style&index=0&id=515fa52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fa52f",
  null
  
)

export default component.exports